import clsx from 'clsx';
import { observer } from 'mobx-react';
import { DeactivateSucceeded } from '../../Store/Types';
import ModalStore from '../../../../../../../Modal/Store';
import BigCheckmarkCircleIcon from '../../../../../../../Cutesies/BigCheckmarkCircleIcon';
import { T } from '../../../../../../../../Translations';
import Button from '../../../../../../../Form/Button';

interface Props {
  state: DeactivateSucceeded;
  modalStore: ModalStore;
}

function DeactivateSuccess({ state, modalStore }: Props) {
  return (
    <div className="flex flex-col w-full items-center">
      <BigCheckmarkCircleIcon width="160" height="160" />
      <div className="text-2xl font-bold">
        <T kind="Collection Access Removed" />
      </div>
      <div className="pt-4 text-center">
        <T
          kind="{{successCount}} of {{totalCount}} participants will no longer..."
          successCount={state.resource.payload.successCount}
          totalCount={state.resource.payload.attemptedCount}
        />
      </div>
      <Button
        type="button"
        value="Done"
        onClick={modalStore.close}
        className={clsx(
          'my-6 cursor-pointer w-72 rounded-md font-semibold',
          'bg-teal-600 px-4 py-2 text-base text-white',
        )}
      />
    </div>
  );
}

export default observer(DeactivateSuccess);
